import { FormControlLabel, styled, typographyClasses } from '@mui/material';
import { COLORS } from '../../../../../../common/Styleguide/Common/colors';

export const StyledFormControlLabel = styled(FormControlLabel)(() => ({
  [`& .${typographyClasses.root}`]: {
    color: COLORS.white[60],
  },
  paddingBottom: 0,
}));
